<template lang="pug">
  v-main#login
    v-container(
      id="login"
      fill-height
    )
      v-row.login-row(
        align="center"
      )
        img(
          @click="$router.push('/')"
          class="p-4"
          src="@/assets/logo.png"
        )
        v-form.login-form(ref="form")
          h1.header-title Welcome
          v-text-field(
            outlined
            prepend-inner-icon="mdi-account"
            v-model="customerId" 
            :rules="idRules"
            required
            label="Username/E-Mail/Phone Number"
            hint="At least 5 characters"
            :counter="20"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-lock"
            v-model="customerPassword" 
            :rules="passwordRules"
            label="Password"
            required
            type="password"
            hint="At least 8 characters"
            :counter="20"
          )
          v-btn(
            class="my-2"
            color="primary"
            @click="customerLogin"
          ) Login &nbsp;
            i.fas.fa-spin.fa-spinner.ml-2(v-if="loading")
          v-btn(
            class="my-2"
            text
            color="primary"
            block 
            depressed
            @click="goto"
          ) No account yet? Click to register.
          h4.header-title.mt-4 Social Media Methods
          section#firebaseui-auth-container.m-auto
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
// v9 compat packages are API compatible with v8 code
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default {
  name: "Login",
  data() {
    return {
      customerId: "",
      customerPassword: "",
      idRules: [
        (v) => !!v || "Username is required",
        (v) => /^[a-z\d.]*$/i.test(v) || "Username must be alphanumeric only.",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
      ],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed,
      },
    };
  },
  mounted() {
    $(".v-footer").css("margin-bottom", "0px");
    $(document).off("keypress");
    $(document).keypress((event) => {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode == "13") this.customerLogin();
    });

    //firebase setup
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (ui == null) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start("#firebaseui-auth-container", this.getUiConfig());
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  },
  methods: {
    getUiConfig() {
      return {
        callbacks: {
          // Called when the user has been successfully signed in.
          signInSuccessWithAuthResult: (authResult, redirectUrl) => {
            if (authResult.user) {
              this.firebaseLogin(authResult.user);
            }
          },
        },
        signInFlow: "popup",
        signInSuccessUrl: "/",
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          // firebase.auth.TwitterAuthProvider.PROVIDER_ID
        ],
        // Terms of service url.
        // tosUrl: "https://www.google.com",
        // // Privacy policy url.
        // privacyPolicyUrl: "https://www.google.com",
        credentialHelper: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM,
        // credentialHelper:
        //   CLIENT_ID && CLIENT_ID != "YOUR_OAUTH_CLIENT_ID"
        //     ? firebaseui.auth.CredentialHelper.GOOGLE_YOLO
        //     : firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
      };
    },
    goto() {
      this.$router.push("/register");
    },
    customerLogin() {
      if (!this.$refs.form.validate()) return;

      let url = config.loginUrl();

      var json = {
        customer_id: this.customerId,
        customer_password: md5(this.customerPassword),
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.$store.commit(
                  "customer/customerLogin",
                  response.body.data[0]
                );
                this.$router.push("/");
              } else {
                this.$swal(
                  this.$t("error.login"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(this.$t("error.login"), response.body.message, "error");
          }
        })
        .catch((response) => {
          this.feedback.success = false;
          this.$swal(this.$t("error.login"), response.body.message, "error");
        });
    },
  },
};
</script>
